const translations = {
  en: {
    dashboard: "Dashboard",
    clients: "Clients",
    settings: "Settings",
    reminders: "Reminders",
    search: "Search...",
    add_client: "Add Client",
    edit_client: "Edit Client",
    trust_details: "Trust Details",
    registration_details: "Registration Details",
    bank_details: "Bank Details",
    documents: "Documents",
    upload_documents: "Upload Documents",
    trust_name: "Trust Name",
    trust_number: "Trust Number",
    trust_pan: "Trust PAN Number",
    trustee_name: "Trustee Name",
    trustee_number: "Trustee Number",
    email: "Email",
    phone: "Phone",
    address: "Address",
    category: "Category",
    registration_12a: "12A Number",
    registration_80g: "80G Number",
    bank_account: "Bank Account Number",
    bank_ifsc: "IFSC Code",
    bank_name: "Bank Name",
    financial_year: "Financial Year",
    status: "Status",
    active: "Active",
    inactive: "Inactive",
    actions: "Actions",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    view: "View",
    print: "Print",
    export_csv: "Export CSV",
    bulk_delete: "Bulk Delete",
    total_clients: "Total Clients",
    active_clients: "Active Clients",
    inactive_clients: "Inactive Clients",
    total_documents: "Total Documents",
    pending_reminders: "Pending Reminders",
    recent_activity: "Recent Activity",
    company_settings: "Company Settings",
    user_management: "User Management",
    category_management: "Category Management",
    company_name: "Company Name",
    add_user: "Add User",
    add_category: "Add Category",
    name: "Name",
    role: "Role",
    password: "Password",
    admin: "Admin",
    staff: "Staff",
    trust_id: "Trust ID",
    created_at: "Created At",
    date_of_creation: "Date of Creation",
    no_data: "No data found",
    loading: "Loading...",
    confirm_delete: "Are you sure?",
    logout: "Logout",
    login: "Login",
    sign_in: "Sign In",
    welcome_back: "Welcome Back",
    sign_in_desc: "Sign in to your account",
    all: "All",
    select_category: "Select Category",
    select_fy: "Select FY",
    select_status: "Select Status",
    client_profile: "Client Profile",
    activity_log: "Activity Log",
    compliance_reminders: "Compliance Reminders",
    reminder_type: "Reminder Type",
    due_date: "Due Date",
    notes: "Notes",
    add_reminder: "Add Reminder",
    pending: "Pending",
    completed: "Completed",
    overdue: "Overdue",
    twelve_a_renewal: "12A Renewal",
    eighty_g_renewal: "80G Renewal",
    filing_due_date: "Filing Due Date",
    upload_logo: "Upload Logo",
    dark_mode: "Dark Mode",
  },
  gu: {
    dashboard: "\u0AA1\u0AC7\u0AB6\u0AAC\u0ACB\u0AB0\u0ACD\u0AA1",
    clients: "\u0A95\u0ACD\u0AB2\u0ABE\u0AAF\u0AA8\u0ACD\u0A9F\u0ACD\u0AB8",
    settings: "\u0AB8\u0AC7\u0A9F\u0ABF\u0A82\u0A97\u0ACD\u0AB8",
    reminders: "\u0AB0\u0ABF\u0AAE\u0ABE\u0A87\u0AA8\u0ACD\u0AA1\u0AB0",
    search: "\u0AB6\u0ACB\u0AA7\u0ACB...",
    add_client: "\u0A95\u0ACD\u0AB2\u0ABE\u0AAF\u0AA8\u0ACD\u0A9F \u0A89\u0AAE\u0AC7\u0AB0\u0ACB",
    edit_client: "\u0A95\u0ACD\u0AB2\u0ABE\u0AAF\u0AA8\u0ACD\u0A9F \u0AB8\u0AC1\u0AA7\u0ABE\u0AB0\u0ACB",
    trust_details: "\u0A9F\u0ACD\u0AB0\u0AB8\u0ACD\u0A9F \u0AB5\u0ABF\u0A97\u0AA4\u0ACB",
    registration_details: "\u0AA8\u0ACB\u0A82\u0AA7\u0AA3\u0AC0 \u0AB5\u0ABF\u0A97\u0AA4\u0ACB",
    bank_details: "\u0AAC\u0AC7\u0A82\u0A95 \u0AB5\u0ABF\u0A97\u0AA4\u0ACB",
    documents: "\u0AA6\u0AB8\u0ACD\u0AA4\u0ABE\u0AB5\u0AC7\u0A9C\u0ACB",
    upload_documents: "\u0AA6\u0AB8\u0ACD\u0AA4\u0ABE\u0AB5\u0AC7\u0A9C \u0A85\u0AAA\u0AB2\u0ACB\u0AA1 \u0A95\u0AB0\u0ACB",
    trust_name: "\u0A9F\u0ACD\u0AB0\u0AB8\u0ACD\u0A9F \u0AA8\u0ABE\u0AAE",
    trust_number: "\u0A9F\u0ACD\u0AB0\u0AB8\u0ACD\u0A9F \u0AA8\u0A82\u0AAC\u0AB0",
    trust_pan: "\u0A9F\u0ACD\u0AB0\u0AB8\u0ACD\u0A9F PAN \u0AA8\u0A82\u0AAC\u0AB0",
    trustee_name: "\u0A9F\u0ACD\u0AB0\u0AB8\u0ACD\u0A9F\u0AC0 \u0AA8\u0ABE\u0AAE",
    trustee_number: "\u0A9F\u0ACD\u0AB0\u0AB8\u0ACD\u0A9F\u0AC0 \u0AA8\u0A82\u0AAC\u0AB0",
    email: "\u0A87\u0AAE\u0AC7\u0AB2",
    phone: "\u0AAB\u0ACB\u0AA8",
    address: "\u0AB8\u0AB0\u0AA8\u0ABE\u0AAE\u0AC1\u0A82",
    category: "\u0AB6\u0ACD\u0AB0\u0AC7\u0AA3\u0AC0",
    registration_12a: "12A \u0AA8\u0A82\u0AAC\u0AB0",
    registration_80g: "80G \u0AA8\u0A82\u0AAC\u0AB0",
    bank_account: "\u0AAC\u0AC7\u0A82\u0A95 \u0A96\u0ABE\u0AA4\u0ABE \u0AA8\u0A82\u0AAC\u0AB0",
    bank_ifsc: "IFSC \u0A95\u0ACB\u0AA1",
    bank_name: "\u0AAC\u0AC7\u0A82\u0A95 \u0AA8\u0ABE\u0AAE",
    financial_year: "\u0AA8\u0ABE\u0AA3\u0ABE\u0A95\u0AC0\u0AAF \u0AB5\u0AB0\u0ACD\u0AB7",
    status: "\u0AB8\u0ACD\u0AA5\u0ABF\u0AA4\u0ABF",
    active: "\u0AB8\u0A95\u0ACD\u0AB0\u0ABF\u0AAF",
    inactive: "\u0AA8\u0ABF\u0AB7\u0ACD\u0A95\u0ACD\u0AB0\u0ABF\u0AAF",
    actions: "\u0A95\u0ACD\u0AB0\u0ABF\u0AAF\u0ABE\u0A93",
    save: "\u0AB8\u0ABE\u0A9A\u0AB5\u0ACB",
    cancel: "\u0AB0\u0AA6 \u0A95\u0AB0\u0ACB",
    delete: "\u0A95\u0ABE\u0AA2\u0AC0 \u0AA8\u0ABE\u0A96\u0ACB",
    edit: "\u0AB8\u0AC1\u0AA7\u0ABE\u0AB0\u0ACB",
    view: "\u0A9C\u0AC1\u0A93",
    print: "\u0AAA\u0ACD\u0AB0\u0ABF\u0AA8\u0ACD\u0A9F",
    export_csv: "CSV \u0AA8\u0ABF\u0A95\u0ABE\u0AB8 \u0A95\u0AB0\u0ACB",
    bulk_delete: "\u0AAC\u0AB2\u0ACD\u0A95 \u0A95\u0ABE\u0AA2\u0AC0 \u0AA8\u0ABE\u0A96\u0ACB",
    total_clients: "\u0A95\u0AC1\u0AB2 \u0A95\u0ACD\u0AB2\u0ABE\u0AAF\u0AA8\u0ACD\u0A9F\u0ACD\u0AB8",
    active_clients: "\u0AB8\u0A95\u0ACD\u0AB0\u0ABF\u0AAF \u0A95\u0ACD\u0AB2\u0ABE\u0AAF\u0AA8\u0ACD\u0A9F\u0ACD\u0AB8",
    inactive_clients: "\u0AA8\u0ABF\u0AB7\u0ACD\u0A95\u0ACD\u0AB0\u0ABF\u0AAF \u0A95\u0ACD\u0AB2\u0ABE\u0AAF\u0AA8\u0ACD\u0A9F\u0ACD\u0AB8",
    total_documents: "\u0A95\u0AC1\u0AB2 \u0AA6\u0AB8\u0ACD\u0AA4\u0ABE\u0AB5\u0AC7\u0A9C\u0ACB",
    pending_reminders: "\u0AAC\u0ABE\u0A95\u0AC0 \u0AB0\u0ABF\u0AAE\u0ABE\u0A87\u0AA8\u0ACD\u0AA1\u0AB0",
    recent_activity: "\u0AA4\u0ABE\u0A9C\u0AC7\u0AA4\u0AB0\u0AA8\u0AC0 \u0AAA\u0ACD\u0AB0\u0AB5\u0AC3\u0AA4\u0ACD\u0AA4\u0ABF",
    company_settings: "\u0A95\u0A82\u0AAA\u0AA8\u0AC0 \u0AB8\u0AC7\u0A9F\u0ABF\u0A82\u0A97\u0ACD\u0AB8",
    user_management: "\u0AB5\u0AAA\u0AB0\u0ABE\u0AB6\u0A95\u0AB0\u0ACD\u0AA4\u0ABE \u0AB5\u0ACD\u0AAF\u0AB5\u0AB8\u0ACD\u0AA5\u0ABE\u0AAA\u0AA8",
    category_management: "\u0AB6\u0ACD\u0AB0\u0AC7\u0AA3\u0AC0 \u0AB5\u0ACD\u0AAF\u0AB5\u0AB8\u0ACD\u0AA5\u0ABE\u0AAA\u0AA8",
    company_name: "\u0A95\u0A82\u0AAA\u0AA8\u0AC0 \u0AA8\u0ABE\u0AAE",
    add_user: "\u0AB5\u0AAA\u0AB0\u0ABE\u0AB6\u0A95\u0AB0\u0ACD\u0AA4\u0ABE \u0A89\u0AAE\u0AC7\u0AB0\u0ACB",
    add_category: "\u0AB6\u0ACD\u0AB0\u0AC7\u0AA3\u0AC0 \u0A89\u0AAE\u0AC7\u0AB0\u0ACB",
    name: "\u0AA8\u0ABE\u0AAE",
    role: "\u0AAD\u0AC2\u0AAE\u0ABF\u0A95\u0ABE",
    password: "\u0AAA\u0ABE\u0AB8\u0AB5\u0AB0\u0ACD\u0AA1",
    admin: "\u0A8F\u0AA1\u0AAE\u0ABF\u0AA8",
    staff: "\u0AB8\u0ACD\u0A9F\u0ABE\u0AAB",
    trust_id: "\u0A9F\u0ACD\u0AB0\u0AB8\u0ACD\u0A9F ID",
    created_at: "\u0AAC\u0AA8\u0ABE\u0AB5\u0AC7\u0AB2 \u0AA4\u0ABE\u0AB0\u0AC0\u0A96",
    date_of_creation: "\u0AB0\u0A9A\u0AA8\u0ABE \u0AA4\u0ABE\u0AB0\u0AC0\u0A96",
    no_data: "\u0A95\u0ACB\u0A88 \u0AA1\u0AC7\u0A9F\u0ABE \u0AAE\u0AB3\u0ACD\u0AAF\u0ACB \u0AA8\u0AA5\u0AC0",
    loading: "\u0AB2\u0ACB\u0AA1 \u0AA5\u0A88 \u0AB0\u0AB9\u0ACD\u0AAF\u0AC1\u0A82 \u0A9B\u0AC7...",
    confirm_delete: "\u0AB6\u0AC1\u0A82 \u0AA4\u0AAE\u0AC7 \u0A96\u0ABE\u0AA4\u0AB0\u0AC0 \u0A9B\u0ACB?",
    logout: "\u0AB2\u0ACB\u0A97\u0A86\u0A89\u0A9F",
    login: "\u0AB2\u0ACB\u0A97\u0ABF\u0AA8",
    sign_in: "\u0AB8\u0ABE\u0A87\u0AA8 \u0A87\u0AA8",
    welcome_back: "\u0AAA\u0ABE\u0A9B\u0ABE \u0A86\u0AB5\u0ACB",
    sign_in_desc: "\u0AA4\u0AAE\u0ABE\u0AB0\u0ABE \u0A96\u0ABE\u0AA4\u0ABE\u0AAE\u0ABE\u0A82 \u0AB8\u0ABE\u0A87\u0AA8 \u0A87\u0AA8 \u0A95\u0AB0\u0ACB",
    all: "\u0AAC\u0AA7\u0ABE",
    select_category: "\u0AB6\u0ACD\u0AB0\u0AC7\u0AA3\u0AC0 \u0AAA\u0AB8\u0A82\u0AA6 \u0A95\u0AB0\u0ACB",
    select_fy: "FY \u0AAA\u0AB8\u0A82\u0AA6 \u0A95\u0AB0\u0ACB",
    select_status: "\u0AB8\u0ACD\u0AA5\u0ABF\u0AA4\u0ABF \u0AAA\u0AB8\u0A82\u0AA6 \u0A95\u0AB0\u0ACB",
    client_profile: "\u0A95\u0ACD\u0AB2\u0ABE\u0AAF\u0AA8\u0ACD\u0A9F \u0AAA\u0ACD\u0AB0\u0ACB\u0AAB\u0ABE\u0A87\u0AB2",
    activity_log: "\u0AAA\u0ACD\u0AB0\u0AB5\u0AC3\u0AA4\u0ACD\u0AA4\u0ABF \u0AB2\u0ACB\u0A97",
    compliance_reminders: "\u0A85\u0AA8\u0AC1\u0AAA\u0ABE\u0AB2\u0AA8 \u0AB0\u0ABF\u0AAE\u0ABE\u0A87\u0AA8\u0ACD\u0AA1\u0AB0",
    reminder_type: "\u0AB0\u0ABF\u0AAE\u0ABE\u0A87\u0AA8\u0ACD\u0AA1\u0AB0 \u0AAA\u0ACD\u0AB0\u0A95\u0ABE\u0AB0",
    due_date: "\u0AA8\u0ABF\u0AAF\u0AA4 \u0AA4\u0ABE\u0AB0\u0AC0\u0A96",
    notes: "\u0AA8\u0ACB\u0A82\u0AA7",
    add_reminder: "\u0AB0\u0ABF\u0AAE\u0ABE\u0A87\u0AA8\u0ACD\u0AA1\u0AB0 \u0A89\u0AAE\u0AC7\u0AB0\u0ACB",
    pending: "\u0AAC\u0ABE\u0A95\u0AC0",
    completed: "\u0AAA\u0AC2\u0AB0\u0ACD\u0AA3",
    overdue: "\u0AAE\u0AC1\u0AA6\u0AA4 \u0AB5\u0AC0\u0AA4\u0AC0 \u0A97\u0AAF\u0AC7\u0AB2",
    twelve_a_renewal: "12A \u0AA8\u0AB5\u0AC0\u0A95\u0AB0\u0AA3",
    eighty_g_renewal: "80G \u0AA8\u0AB5\u0AC0\u0A95\u0AB0\u0AA3",
    filing_due_date: "\u0AAB\u0ABE\u0A87\u0AB2\u0ABF\u0A82\u0A97 \u0AA8\u0ABF\u0AAF\u0AA4 \u0AA4\u0ABE\u0AB0\u0AC0\u0A96",
    upload_logo: "\u0AB2\u0ACB\u0A97\u0ACB \u0A85\u0AAA\u0AB2\u0ACB\u0AA1 \u0A95\u0AB0\u0ACB",
    dark_mode: "\u0AA1\u0ABE\u0AB0\u0ACD\u0A95 \u0AAE\u0ACB\u0AA1",
  },
};

export default translations;
